export default {"src":"/blog/_next/static/media/info.673637ca.svg","height":24,"width":24};